export default function FormInputPassword(props: {
    name: string;
    value?: string;
    readOnly?: boolean;
    required?: boolean;
    onChange?: (value: string) => void;
    className?: string;
    placeholder?: string;
    autoComplete?: "on" | "off" | "new-password";
}) {
    return (
        <input
            type="password"
            className={`form-control ${props.className ?? ""}`}
            id={`textbox-${props.name}`}
            aria-describedby={`textbox-${props.name}`}
            required={props.required}
            readOnly={props.readOnly}
            value={props.value ?? ""}
            name={props.name}
            onChange={props.onChange != null ? e => props.onChange?.(e.currentTarget.value) : () => {}}
            placeholder={props.placeholder}
            autoComplete={props.autoComplete}
        />
    );
}
